module.exports = __webpack_public_path__ + "img/construccion.f5f3489b.png";